const BUSY_DATASET_KEY = 'makermarginBusy';

function appRoot(root) {
  if (root) return root;
  return typeof document === 'undefined' ? null : document.documentElement;
}

export function markAppBusy(token, root) {
  const target = appRoot(root);
  if (!target?.dataset) return;
  target.dataset[BUSY_DATASET_KEY] = String(token || 'busy');
}

export function clearAppBusy(token, root) {
  const target = appRoot(root);
  if (!target?.dataset) return;
  if (token && target.dataset[BUSY_DATASET_KEY] !== String(token)) return;
  delete target.dataset[BUSY_DATASET_KEY];
}

export function isAppBusy(root) {
  return Boolean(appRoot(root)?.dataset?.[BUSY_DATASET_KEY]);
}
